import AGENCY_API from '@/api/agencyContract/index';
export function CHECK_EXTERNAL_CONTRACTNO(params) {
  /* 采购、销售、服务合同、升贴水合同：
    url：/order/checkExternalContractNo
    入参：json格式
    id：修改时传，用于排除自身
    purchaseExternalContractNo:外部合同号(采购端)
    salesExternalContractNo:外部合同号(代理端) */
  return new Promise((resolve) => {
    window.vm.$axios.post(AGENCY_API.CHECK_EXTERNAL_CONTRACTNO, params).then((res) => {
      if (0 != res.data.code) {
        window.vm.$repeatConfirm(
          "<div><img src='/static/img/tips.png'/>" +
            "<div class='repeatContent'>" +
            res.data.msg +
            '</div></div>',
          '',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: window.vm.$t('salePurchase.message.submitAgain'),
            cancelButtonText: window.vm.$t('confirm.cancel'),
            center: true,
            callback: (action) => {
              if (action === 'confirm') {
                resolve(true);
              } else {
                resolve(false);
                window.vm.$message({
                  type: 'info',
                  message: window.vm.$t('salePurchase.message.gitUpSubmitAgain'),
                });
              }
            },
          }
        );
      } else {
        resolve(true);
      }
    });
  });
}
